import { useApi } from '@/api';
import { ChartSkeleton } from '@/components';
import { useChartTooltip } from '@/hooks';
import {
  DoughnutChart,
  Flex,
  formatPercentage,
  textShortener
} from '@blockanalitica/ui';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

export default function HoldersDonutChart() {
  const [data, error] = useApi({
    url: '/save/dsr/share/'
  });

  const navigate = useNavigate();
  const customTooltip = useChartTooltip(
    data,
    'wallet_address',
    'percent_of_total',
    true,
    'balance'
  );

  const chartData = useMemo(() => {
    if (data) {
      const mapping = data.reduce((acc, row) => {
        const shortenedAddress = textShortener(row.wallet_address);
        if (shortenedAddress === 'others') {
          acc[shortenedAddress] = 'suppliers';
        } else {
          acc[shortenedAddress] = `suppliers/${row.wallet_address}`;
        }
        return acc;
      }, {});

      return {
        data: {
          labels: data.map((row) => textShortener(row.wallet_address)),
          datasets: [
            {
              data: data.map((row) => row.percent_of_total),
              hoverOffset: 30
            }
          ]
        },
        mapping
      };
    }

    return null;
  }, [data]);

  const customConfig = useMemo(
    () => ({
      options: {
        aspectRatio: 1.8,
        layout: {
          padding: 10
        },
        plugins: {
          legend: {
            position: 'bottom'
          },
          tooltip: {
            enabled: false,
            position: 'nearest',
            external: customTooltip
          }
        }
      }
    }),
    [customTooltip]
  );

  if (error) {
    throw error;
  }

  if (chartData) {
    return (
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        paddingTop="m"
        width="100%">
        <DoughnutChart
          // @ts-ignore
          config={customConfig}
          data={chartData.data}
          valueFormatter={formatPercentage}
          url={`/savings/dai-savings-rate`}
          mapping={chartData.mapping}
          navigate={navigate}
        />
      </Flex>
    );
  }

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      paddingTop="m"
      width="100%">
      <ChartSkeleton type="doughnut" />
    </Flex>
  );
}
